var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"menu-style",style:({ top: _vm.y + 'px', left: _vm.x + 'px' })},[_c('ul',[_c('li',{on:{"click":function () {
          _vm.$emit('copy')
        }}},[_c('span',{staticClass:"copy-button",attrs:{"type":"link"}},[_vm._v("复制")])]),_c('li',{on:{"click":function () {
          _vm.$emit('add')
        }}},[_c('span',{staticClass:"copy-button",attrs:{"type":"link"}},[_vm._v("添加节点")])]),_c('li',{on:{"click":function () {
          _vm.$emit('paste-node')
        }}},[_c('span',{staticClass:"copy-button",attrs:{"type":"link"}},[_vm._v("粘贴子节点")])]),_c('li',{on:{"click":function () {
          _vm.$emit('del')
        }}},[_c('span',{staticClass:"copy-button",attrs:{"type":"link"}},[_vm._v("删除")])])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }